export function getVCRevisionDebugDetails(_ref) {
  var revision = _ref.revision,
    isClean = _ref.isClean,
    abortReason = _ref.abortReason,
    VCEntries = _ref.VCEntries,
    componentsLog = _ref.componentsLog,
    interactionId = _ref.interactionId;
  return {
    revision: revision,
    isClean: isClean,
    abortReason: abortReason,
    vcLogs: VCEntries.map(function (entry) {
      return {
        time: entry.time,
        viewportPercentage: entry.vc,
        entries: entry.elements.map(function (element) {
          var _componentsLog$entry$;
          var logEntry = (_componentsLog$entry$ = componentsLog[entry.time]) === null || _componentsLog$entry$ === void 0 ? void 0 : _componentsLog$entry$.find(function (log) {
            return log.targetName === element;
          });
          return {
            elementName: element,
            type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
            rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
            visible: true,
            attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
            oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
            newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue
          };
        })
      };
    }),
    interactionId: interactionId
  };
}